// extracted by mini-css-extract-plugin
export default {"draft-invoice-filters":"SearchFilter_draft-invoice-filters__AJlTX"};